import { render, staticRenderFns } from "./WindControlInfo01.vue?vue&type=template&id=7295c83e&"
import script from "./WindControlInfo01.vue?vue&type=script&lang=js&"
export * from "./WindControlInfo01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports